import {headers} from 'src/services/auth';

/**
 * Retrieves an AI reply to a given merchant id, survey id and type
 * @param {String} merchantId The id for the merchant
 * @param {String} surveyId The id for the survey
 * @param {String} type The type of the reply
 * @returns {Promise<String>} An string with the AI reply
 */
export function generateAIReply(merchantId, surveyId, type) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;

  const data = {type: type, regenerate: true};
  return fetch(`${baseURL}v3/api/merchants/${merchantId}/Surveys/${surveyId}/generate-ai-reply`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  })
  .then(result => result.text());
}

export function getActiveTags(merchantId, signal = null) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;

  const query =
  `?TagType=SurveyResponses` +
  `&Active=true` +
  `&PageSize=2500`

  return fetch(`${baseURL}v3/api/merchants/${merchantId}/tags${query}`, {
    method: 'GET',
    headers: headers,
    signal
  })
  .then(result => result.json());
}

export function getTagsFromSurvey(merchantId, surveyId, signal=null) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;

  return fetch(`${baseURL}v3/api/merchants/${merchantId}/Surveys/${surveyId}/tags`, {
    method: 'GET',
    headers: headers,
    signal
  })
  .then(result => result.json());
}

export function addTagsToSurvey(merchantId, surveyId, tags) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;

  return fetch(`${baseURL}v3/api/merchants/${merchantId}/Surveys/${surveyId}/tags`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(tags)
  })
  .then(result => result);
}

export function setReviewUser(merchantId, incidentId, params) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;

  return fetch(`${baseURL}v3/api/merchants/${merchantId}/incidents/${incidentId}`, {
    method: 'PATCH',
    headers: headers,
    body: JSON.stringify(params)
  })
  .then(result => result);
}

export function getSurveyChannelDelays(merchantId) {
    const baseURL = window.INTEGRATIONS_ENGINE_URL;

    return fetch(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/channel-delays`, {
        method: 'GET',
        headers: headers,
    }).then(result => result.json());
}

export async function updateSurveyDelaysByChannel(merchantId, surveyChannelDelays) {
    const baseURL = window.INTEGRATIONS_ENGINE_URL;
    const requestBody = { ChannelDelays: surveyChannelDelays, MerchantId: merchantId };

    await fetch(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/channel-delays`, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(requestBody)
    });
}

export function deleteSurveyDelaysByChannel(merchantId, channelIds) {
    const baseURL = window.INTEGRATIONS_ENGINE_URL;

    return fetch(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/channel-delays`, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify({ channelIds })
    }).then(result => result);
}

export function getRestrictedDomains(merchantId, sortBy = null, sortOrder = 'Ascending') {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;
  const url = new URL(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/restricted-domains`);
  
  if (sortBy) {
    url.searchParams.append('sortBy', sortBy);
  }
  if (sortOrder) {
    url.searchParams.append('sortOrder', sortOrder);
  }

  return fetch(url.toString(), {
    method: 'GET',
    headers: headers,
  }).then(result => result.json());
}

export function createRestrictedDomain(merchantId, domainType, value) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;
  const url = new URL(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/restricted-domains`);

  return fetch(url.toString(), {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      domainType: domainType,
      value: value
    }),
  }).then(result => result.json());
}

export function deleteRestrictedDomain(merchantId, domainType, value) {
  const baseURL = window.INTEGRATIONS_ENGINE_URL;
  const url = new URL(`${baseURL}v3/api/merchants/${merchantId}/surveys-configuration/restricted-domains`);

  const requestBody = {
    domainType: domainType,
    value: value
  };

  return fetch(url.toString(), {
    method: 'DELETE',
    headers: headers,
    body: JSON.stringify(requestBody)
  }).then(result => result);
}